module.exports = __webpack_public_path__ + "static/media/guidelines_collage.afbb4735.jpg";